import { useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

function ProduitsParCollection() {
  const { id } = useParams();
  const [collectionName, setCollectionName] = useState("");
  const [collectionIllustration, setCollectionIllustration] = useState("");
  const [produits, setProduits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categorie, setCategorie] = useState("");
  const gridRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    fetch(`https://adawall.ma/php/api/collection.php`)
      .then(res => res.json())
      .then(data => {
        const col = Array.isArray(data) ? data.find(c => String(c.idCollection) === String(id)) : null;
        setCollectionName(col ? col.nomCollection : "");
        setCollectionIllustration(col ? col.illustration : "");
        setCategorie(col ? col.nomCategorie?.toLowerCase() : "");
      });
  }, [id]);

  useEffect(() => {
    if (!categorie) return;
    setLoading(true);
    let apiUrl = "";
    if (categorie === "posters" || categorie === "adahome") {
      apiUrl = `https://adawall.ma/php/api/produits_posters.php?idCollection=${id}`;
    } else if (categorie === "moulding" || categorie === "adaaccessories") {
      apiUrl = `https://adawall.ma/php/api/produits_moulding.php?idCollection=${id}`;
    } else {
      apiUrl = `https://adawall.ma/php/api/produits_par_collection.php?idCollection=${id}`;
    }
    fetch(apiUrl)
      .then(res => res.json())
      .then(data => {
        setProduits(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch(() => {
        setProduits([]);
        setLoading(false);
      });
  }, [id, categorie]);

  const scrollToGrid = () => {
    if (gridRef.current) {
      gridRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="produits-collection-page">
      {collectionIllustration && (
        <div className="collection-banner-fullscreen">
          <img
            className="collection-banner-img-full"
            src={`https://adawall.ma/uploads/${collectionIllustration.trim()}`}
            alt={collectionName}
          />
          <div className="collection-banner-title-full">{collectionName}</div>
          <button className="scroll-down-arrow" onClick={scrollToGrid} aria-label="Voir les produits">
            <svg width="38" height="38" viewBox="0 0 38 38" fill="none">
              <circle cx="19" cy="19" r="19" fill="rgba(255,255,255,0.7)" />
              <path d="M12 16l7 7 7-7" stroke="#96292A" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>
      )}
      {loading ? (
        <div className="produits-loader">
          <div className="loader" />
          Chargement des produits...
        </div>
      ) : (
        <div className="products-grid" ref={gridRef}>
          {Array.isArray(produits) && produits.length === 0 ? (
            <div className="no-products">Aucun produit trouvé.</div>
          ) : (
            Array.isArray(produits) && produits.map(prod => (
              <ProductItem 
                key={prod.idProduit} 
                prod={prod} 
                collectionName={collectionName} 
              />
            ))
          )}
        </div>
      )}
    </div>
  );
}

// Composant pour un produit individuel avec gestion du survol et navigation
function ProductItem({ prod, collectionName }) {
  const [isHovered, setIsHovered] = useState(false);
  const [imgLoaded, setImgLoaded] = useState(false);
  const navigate = useNavigate();

  const imageUrl1 = prod.image_ordre_1 
    ? `https://adawall.ma/uploads/${prod.image_ordre_1.trim()}` 
    : ''
  const imageUrl3 = prod.image_ordre_3 
    ? `https://adawall.ma/uploads/${prod.image_ordre_3.trim()}` 
    : '';

  // Redirection au clic sur l'image ou le label
  const handleRedirect = () => {
    window.scrollTo(0, 0); 
    navigate(`/reference/${prod.idReference}`);
  };

  return (
    <div 
      className="product-gallery-item"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div 
        className="product-image-container"
        onClick={handleRedirect}
        style={{ cursor: "pointer", position: "relative" }}
      >
        {!imgLoaded && (
          <div
            style={{
              position: "absolute",
              inset: 0,
              background: "#f2f2f2",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 1
            }}
          >
            <div className="loader" style={{ width: 32, height: 32 }} />
          </div>
        )}
        <img
          src={isHovered && imageUrl3 ? imageUrl3 : imageUrl1}
          alt={`Produit ${prod.idProduit}`}
          className={`product-gallery-img ${isHovered ? 'zoomed' : ''}`}
          onLoad={() => setImgLoaded(true)}
          onError={(e) => {
            e.target.src = 'https://via.placeholder.com/300x300?text=Image+Non+Disponible';
            setImgLoaded(true);
          }}
          style={imgLoaded ? {} : { visibility: "hidden" }}
        />
      </div>
      <div 
        className="product-gallery-label"
        onClick={handleRedirect}
        style={{ cursor: "pointer" }}
      >
        <span className="product-gallery-name">{collectionName}</span>
        <span className="product-gallery-ref"> - {prod.idProduit}</span>
      </div>

      <a
        href="https://wa.me/212664664692"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
      >
        <img
          src="/assets/icons/whatsapp.png"
          alt="WhatsApp"
          style={{ width: 40, height: 40 }}
        />
      </a>
    </div>
  );
}

export default ProduitsParCollection;